export default "__VITE_ASSET__BfYBmOUb__"